import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { BundlePage } from '@/features/bundles/bundle-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/bundles/nouveau` — création d'un bundle (`02` §8). Déclarée **avant**
 * `/bundles/$sku` dans `router.tsx` : sans cela, « nouveau » serait pris pour
 * un SKU.
 */
function NewBundleRoute(): JSX.Element {
  return <BundlePage isNew />;
}

export const bundleNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/bundles/nouveau',
  component: NewBundleRoute,
});
